
let BaseTest = require('@/mixins/Forms/2016/BaseTest')

module.exports = {

    mixins: [BaseTest],

    data () {
        return {
            // Main result for Contruction Inspection, in the end
            // Of each individual form we have to check this property is true
            // plus the functionalTest value of each area.
            constructionInspectionResult: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            skylit: false,
            primarySidelit: false,
            secondaySidelit: false,

            // As part of the contruction Inspection there is one item on Secion 3 that require a personal calculation
            sensorLocationAppropiate: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            testResult: 0
        }
    },

    methods: {

        constructionInspection () {

            this.updateZones();

            if (this.skylit) {
                this.intereactWithTestedZone('SKY')
            } else {
                this.sensorLocationAppropiate.SKY = 0;
                this.constructionInspectionResult.SKY = 0
            }
            if (this.primarySidelit) {
                this.intereactWithTestedZone('PS')
            } else {
                this.sensorLocationAppropiate.PS = 0;
                this.constructionInspectionResult.PS = 0
            }
            if (this.secondaySidelit) {
                this.intereactWithTestedZone('SS')
            } else {
                this.sensorLocationAppropiate.SS = 0;
                this.constructionInspectionResult.SS = 0
            }
        },

        updateZones () {
            this.skylit = $('input[name="skylit"]').is(":checked");
            this.primarySidelit = $('input[name="primary_sidelit"]').is(":checked");
            this.secondaySidelit = $('input[name="seconday_sidelit"]').is(":checked");
        },

        // Interact only with the zones checked for test.
        intereactWithTestedZone (zone) {
            if (! this.sensonLocationIsAppropiateToControlType(zone)) {
                this.constructionInspectionResult[zone] = 0;
                return false;
            }
            if ($('input[name="ctr_adj_app_loc_' + zone + '"]:checked').val() == 0) {
                this.constructionInspectionResult[zone] = 0;
                return false;
            }

            if ($('input[name="inst_prov_to_build_owner_' + zone + '"]:checked').val() == 0) {
                this.constructionInspectionResult[zone] = 0;
                return false;
            }
            if ($('input[name="loc_light_sens_plans_' + zone + '"]:checked').val() == 0) {
                this.constructionInspectionResult[zone] = 0;
                return false;
            }
            if ($('input[name="are_lum_in_daylit_zones_' + zone + '"]:checked').val() == 0) {
                this.constructionInspectionResult[zone] = 0;
                return false;
            }
            if ($('input[name="seper_circ_for_daylit_by_win_udr_skylights_' + zone + '"]:checked').val() == 0) {
                this.constructionInspectionResult[zone] = 0;
                return false;
            }
            if ($('input[name="daylighting_ctrl_certified_' + zone + '"]:checked').val() == 0) {
                this.constructionInspectionResult[zone] = 0;
                return false;
            }
            this.constructionInspectionResult[zone] = 1;
        },

        // Resolve one of the requirements of the test.
        sensonLocationIsAppropiateToControlType (zone) {
            var controlType = $('input[name="control_loop_type_' + zone + '"]:checked').val();
            var sensorLocation = $('input[name="sensor_location_' + zone + '"]:checked').val();

            if (controlType == 'OL' && (sensorLocation == 'O' || sensorLocation == 'IS' || sensorLocation == 'NW')){
                this.sensorLocationAppropiate[zone] = 1;
                return true;
            }
            if (controlType == 'CL' && (sensorLocation == 'CZ')){
                this.sensorLocationAppropiate[zone] = 1;
                return true;
            }
            this.sensorLocationAppropiate[zone] = 0;
            return false;
        },

        // Make sure if some value is not empty.
        isBlank(value) {
            return $.trim(value) == '';
        },

        // Return the original value of input if is not a number return 0.
        asNumber(val){
            return (isNaN(val) || val == "") ? '' : eval(val)
        }
    }
}
